import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import { TimePicker as MUITimePicker } from '@mui/x-date-pickers';

// See KeyboardDatePicker.js for why this normalization is needed.
const toMoment = value => (
  value === null || typeof value === 'undefined' || moment.isMoment(value) ? value : moment(value)
);

export const KeyboardTimePicker = ({
  DialogProps,
  KeyboardButtonProps,
  autoOk,  // eslint-disable-line no-unused-vars
  // mask is accepted for backward compatibility but no longer needed: the new field UI
  // generates its own mask from format/ampm, there's no separate mask prop anymore.
  mask,  // eslint-disable-line no-unused-vars
  error,
  fullWidth,
  helperText,
  id,
  inputProps,
  keyboardIcon,
  margin,
  value,
  ...props
}) => (
  <MUITimePicker
    // See KeyboardDatePicker.js for why this is needed.
    value={toMoment(value)}
    slots={{
      ...(keyboardIcon ? { openPickerIcon: () => keyboardIcon } : {})
    }}
    slotProps={{
      textField: {
        variant: 'standard',
        error,
        fullWidth,
        helperText,
        id,
        margin,
        inputProps,
        // See KeyboardDatePicker.js for why this is needed.
        sx: {
          '& .MuiPickersSectionList-sectionContent': { lineHeight: '1.1876em' }
        }
      },
      openPickerButton: KeyboardButtonProps,
      dialog: DialogProps
    }}
    {...props}
  />
);

KeyboardTimePicker.propTypes = {
  DialogProps: PropTypes.object,
  KeyboardButtonProps: PropTypes.object,
  ampm: PropTypes.bool,
  // autoOk is accepted for backward compatibility but no longer needed: v5 always closes on selection.
  autoOk: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.node,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  keyboardIcon: PropTypes.node,
  label: PropTypes.node,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  mask: PropTypes.string,
  onAccept: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object
};

export default KeyboardTimePicker;
